import Axios from "axios";
import Loader from "./common/Loader";
import React, { useEffect, useState } from "react";
import DateBox from "./controls/DateBox";
import * as constants from "../constants";
import moment from "moment";
import Transition from "./common/Transition";
import { DateFormatter } from "./common/DateFormatter";
import TableComponent from "./common/TableComponent";
import MultiSelection from "./controls/MultiSelection";
import "../assets/css/additional.css";
import { AgentsRequests } from "../apiRequests/AgentsRequests";
import ToolTip from "./common/ToolTip";
import { currencyFormat, multiselectFilter } from "./common/commonFns";
import SearchBox from "./controls/SearchBox";
import Uploader from "./controls/Uploader";
import {downloadCSV} from "./common/csvDownload";

const dateFormatter = new DateFormatter();
const agentsRequests = new AgentsRequests();
const svgs = {
  attachment: (
    <svg
      className="w-5 h-5"
      fill="currentColor"
      viewBox="0 0 20 20"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        d="M3 17a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM6.293 6.707a1 1 0 010-1.414l3-3a1 1 0 011.414 0l3 3a1 1 0 01-1.414 1.414L11 5.414V13a1 1 0 11-2 0V5.414L7.707 6.707a1 1 0 01-1.414 0z"
        clipRule="evenodd"
      ></path>
    </svg>
  ),
};

const PendingProposals = () => {
  const [state, setState] = useState({
    uploadFile: null,
    isOpen: false,
    tableEmpty: "hidden",
    background: "hidden",
    uploaderBkgrd: "hidden",
    dataLength: 0,
    tableRows: [],
    isLoaded: false,
    filterOn: false,
    hidden: "hidden",
    expanded: "",
    allPrograms: [],
    allCampuses: [],
    allIntakes: [],
    fromDate: "",
    toDate: "",
    allAccountManagers: [],
    programsSelectedList: [],
    campusSelectedList: [],
    intakesSelectedList: [],
    acManagerSelectedList: [],
    pProposalData: [],
    PendingProposaloData: [],
    uploaderHidden: "hidden",
    agentId: localStorage.getItem("agentId"),
    sortBy: "",
    fileObjectID: null,
    firstRowIndex: 0,
    lastRowIndex: constants.NUMBEROFROWS - 1,
    upAlphabetSvg: "gray",
    searchFieldValue: "",
    alphabeticOrder: "alphabetic",
    commissionOrder: "commissionLow",
    downAlphabetSvg: "gray",
    upCommissionnSvg: "gray",
    downCommissionnSvg: "gray",
    tooltipHidden: true,
    fileProposalID: null,
  });

  useEffect(() => {
    let startDate = localStorage.getItem("t1StartDate");
    let endDate = localStorage.getItem("t1EndDate");

    // following line of code will turn on the loader
    setState((prevState) => ({
      ...prevState,
      fromDate: startDate,
      toDate: endDate,
    }));
    // pendingProposalData(startDate, endDate);
  }, []);

  // following function will make a new request for data
  const pendingProposalData = (startDate, endDate) => {
    setState((prevState) => ({
      ...prevState,
      hidden: "",
      isLoaded: true
    }));
    agentsRequests.pendingProposalRequest(startDate, endDate).then((result) => {
      loadMultiSelectData(result);
    });
  };

  // following function will generate data for all Multiselect fields
  const loadMultiSelectData = (pProposalData) => {
    let allPrograms = [];
    let allCampuses = [];
    let allIntakes = [];
    let allAccountManagers = [];
    let data = pProposalData;

    data.map((object) => {
      if (allPrograms.some((item) => object.courseName === item)) {
      } else {
        allPrograms.push(object.courseName);
      }
    });

    data.map((object) => {
      if (allCampuses.some((item) => object.campus === item)) {
      } else {
        allCampuses.push(object.campus);
      }
    });

    data.map((object) => {
      if (
        allIntakes.some((item) => object.intake === item) ||
        object.intake === ""
      ) {
      } else {
        allIntakes.push(object.intake);
      }
    });

    data.forEach((object) => {
    const name = object.accountManagerName;
    if (name && !allAccountManagers.includes(name)) {
      allAccountManagers.push(name);
    }
  });
    setState((prevState) => ({
      ...prevState,
      allPrograms: allPrograms,
      allCampuses: allCampuses,
      allIntakes: allIntakes,
      allAccountManagers: allAccountManagers,
      pProposalData: pProposalData,
    }));

    setState((prevState) => ({
      ...prevState,
      hidden: "hidden",
      isLoaded: false
    }));
  };

  const loadData = () => {
    let rowItem = {};
    let tableRows = [];
    let buttonIndex = 0;
    let data = state.pProposalData;

    let firstRowIndex = state.firstRowIndex;
    let lastRowIndex = state.lastRowIndex;

    // following call will filter data
    data = dataProcessor(data);
    data = dataSortingFn(data);

    let dataLength = data.length;

    if (dataLength < parseInt(firstRowIndex) + 1) {
      firstRowIndex = 0;
      lastRowIndex = constants.NUMBEROFROWS - 1;
    }

    if (data != "" && data != null) {
      data.map((object, index) => {
        if (index >= firstRowIndex && index <= lastRowIndex) {
          rowItem.proposalID = object.proposalID;
          rowItem.ImgSrc =
            "https://ui-avatars.com/api/name=" +
            object.studentName +
            "/?background=random";
          rowItem.Label1 = object.studentName;
          rowItem.PillTxt = object.proposalNo;
          rowItem.PillClr = "green";
          rowItem.DescriptionClm1 =
            "Processed On: " + object.proposalDate;

          rowItem.Label2 = object.courseName;
          rowItem.DescriptionClm2 =
            object.courseStartDate +
            " to " +
            object.courseEndDate;

          rowItem.Campus = object.campus;
          rowItem.Value = "$" + currencyFormat(object.commission);

          if (object.accountManagerName) {
            rowItem["Account Manager"] = object.accountManagerName;
          } else {
            rowItem["Account Manager"] = "N/A";
          }

          if (object.intake) {
            rowItem.Label2 = rowItem.Label2 + " (" + object.intake + ")";
          } else {
            rowItem.Label2 = rowItem.Label2 + "";
          }

          tableRows.push({ ...rowItem });
          buttonIndex = buttonIndex + 1;
        }
      });
      if (dataLength < state.pProposalData.length) {
        setState((prevState) => ({ ...prevState, filterOn: true }));
      } else {
        setState((prevState) => ({ ...prevState, filterOn: false }));
      }
    } else {
      //following line will unhide Nodata View
      setState((prevState) => ({ ...prevState, tableEmpty: "" }));
    }

    setState((prevState) => ({ ...prevState, tableRows: tableRows }));
  };

  const setPageIndexFn = (firstRowIndex, lastRowIndex) => {
    setState((prevState) => ({
      ...prevState,
      firstRowIndex: firstRowIndex,
      lastRowIndex: lastRowIndex,
    }));
  };

  const renderTable = () => {
    let appDetailsBtn = tableHeadingButton(
      "Student Details",
      state.alphabeticOrder,
      state.upAlphabetSvg,
      state.downAlphabetSvg
    );
    let commissionBtn = tableHeadingButton(
      "Commission",
      state.commissionOrder,
      state.upCommissionnSvg,
      state.downCommissionnSvg
    );
    let tableHeadings = [
      "Student Details",
      "Program Details",
      "Campus",
      "Account Manager",
      commissionBtn,
      " ",
    ];
    let tableRows = [...state.tableRows];

    return (
      <TableComponent
        tableRows={tableRows}
        tableHeadings={tableHeadings}
        filterOn={state.filterOn}
        dataLength={state.dataLength}
        setPageIndexFn={setPageIndexFn}
        firstRowIndex={state.firstRowIndex}
        lastRowIndex={state.lastRowIndex}
        clmTwoWidth={"w-1/4"}
        numberOfElementsPerPage={constants.NUMBEROFROWS}
      />
    );
  };

  const dataSortingFn = (data) => {
    let sortBy = state.sortBy;
    if (sortBy === "alphabetic") {
      data.sort((a, b) => a.studentName.localeCompare(b.studentName));
    } else if (state.sortBy === "reverseAlphabetic") {
      data.sort((a, b) => b.studentName.localeCompare(a.studentName));
    } else if (state.sortBy === "commissionLow") {
      data.sort(function (a, b) {
        return b.commission - a.commission;
      });
    } else if (state.sortBy === "commissionHigh") {
      data.sort(function (a, b) {
        return a.commission - b.commission;
      });
    }
    return data;
  };

  const dataProcessor = (data) => {
    let originalData = data;

    let programsSelectedList = state.programsSelectedList;
    let campusSelectedList = state.campusSelectedList;
    let intakesSelectedList = state.intakesSelectedList;
    let acManagerSelectedList = state.acManagerSelectedList;

    if (state.searchFieldValue != "") {
      let searchValue = state.searchFieldValue;
      document.getElementById("search").value = searchValue;
      data = data.filter((object) =>
        object.studentName.toUpperCase().includes(searchValue.toUpperCase())
      );
      setState((prevState) => ({ ...prevState, filterOn: true }));
      if (data.length === originalData.length) {
        setState((prevState) => ({ ...prevState, filterOn: false }));
      }
    }

    if (programsSelectedList != "") {
      data = multiselectFilter(data, programsSelectedList, "courseName");
    }
    if (campusSelectedList != "") {
      data = multiselectFilter(data, campusSelectedList, "campus");
    }
    if (intakesSelectedList != "") {
      data = multiselectFilter(data, intakesSelectedList, "intake");
    }

    if (acManagerSelectedList != "") {
      data = multiselectFilter(
        data,
        acManagerSelectedList,
        "accountManagerName"
      );
    }
    // following line of code will set dataLength
    setState((prevState) => ({ ...prevState, dataLength: data.length }));
    return data;
  };

  const tableHeadingButton = (name, order, upSvgClr, downSvgClr) => {
    return (
      <div>
        <div className="hidden lg:block">
          {name}
          <button
            onClick={() => {
              sortingEventHandeler(order);
            }}
            className="ml-2 w-7 h-4 inline-flex items-center justify-center"
          >
            <svg
              className="w-3 h-4 -rotate-180 transform "
              stroke={upSvgClr}
              strokeWidth="2"
              viewBox="0 0 20 20"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                d="M16.707 10.293a1 1 0 010 1.414l-6 6a1 1 0 01-1.414 0l-6-6a1 1 0 111.414-1.414L9 14.586V3a1 1 0 012 0v11.586l4.293-4.293a1 1 0 011.414 0z"
                clipRule="evenodd"
              ></path>
            </svg>
            <svg
              className="w-3 h-4"
              stroke={downSvgClr}
              strokeWidth="2"
              viewBox="0 0 20 20"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                d="M16.707 10.293a1 1 0 010 1.414l-6 6a1 1 0 01-1.414 0l-6-6a1 1 0 111.414-1.414L9 14.586V3a1 1 0 012 0v11.586l4.293-4.293a1 1 0 011.414 0z"
                clipRule="evenodd"
              ></path>
            </svg>
          </button>
        </div>
        <div className="lg:hidden">{name}sss</div>
      </div>
    );
  };

  const sortingEventHandeler = (type) => {
    if (type === "alphabetic") {
      setState((prevState) => ({
        ...prevState,
        sortBy: "alphabetic",
        alphabeticOrder: "reverseAlphabetic",
        upAlphabetSvg: "lightGreen",
        downAlphabetSvg: "gray",
        upCommissionnSvg: "gray",
        downCommissionnSvg: "gray",
      }));
    } else if (type === "reverseAlphabetic") {
      setState((prevState) => ({
        ...prevState,
        sortBy: "reverseAlphabetic",
        alphabeticOrder: "alphabetic",
        upAlphabetSvg: "gray",
        downAlphabetSvg: "lightGreen",
        upCommissionnSvg: "gray",
        downCommissionnSvg: "gray",
      }));
    } else if (type === "commissionHigh") {
      setState((prevState) => ({
        ...prevState,
        sortBy: "commissionHigh",
        commissionOrder: "commissionLow",
        upAlphabetSvg: "gray",
        downAlphabetSvg: "gray",
        upCommissionnSvg: "lightGreen",
        downCommissionnSvg: "gray",
      }));
    } else if (type === "commissionLow") {
      setState((prevState) => ({
        ...prevState,
        sortBy: "commissionLow",
        commissionOrder: "commissionHigh",
        upAlphabetSvg: "gray",
        downAlphabetSvg: "gray",
        upCommissionnSvg: "gray",
        downCommissionnSvg: "lightGreen",
      }));
    }
  };

  const eventHandeler = (index, event) => {
    const fileProposalID = { ...state.tableRows[index]?.proposalID };
    if (event === "attachment" && fileProposalID) {
      setState((prevState) => ({
        ...prevState,
        uploaderBkgrd: "",
        uploaderHidden: "",
        fileProposalID: fileProposalID,
      }));
    } else if (event === "close") {
      setState((prevState) => ({
        ...prevState,
        uploaderBkgrd: "hidden",
        uploaderHidden: "hidden",
      }));
    }
  };

  const searchHandeler = () => {
    var searchValue = document.getElementById("search").value;
    setState((prevState) => ({
      ...prevState,
      searchFieldValue: searchValue,
    }));
  };

  const onMultiSelectChange = (selectedList, item, id) => {
    if (id === "program") {
      setState((prevState) => ({
        ...prevState,
        programsSelectedList: selectedList,
      }));
    } else if (id === "campus") {
      setState((prevState) => ({
        ...prevState,
        campusSelectedList: selectedList,
      }));
    } else if (id === "intake") {
      setState((prevState) => ({
        ...prevState,
        intakesSelectedList: selectedList,
      }));
    } else if (id === "acManager") {
      setState((prevState) => ({
        ...prevState,
        acManagerSelectedList: selectedList,
      }));
    }
  };

  const filtersDropdown = () => {
    let expanded = state.expanded;
    if (expanded) {
      setState((prevState) => ({
        ...prevState,
        isOpen: false,
        expanded: "",
        background: "hidden",
      }));
    } else {
      setState((prevState) => ({
        ...prevState,
        isOpen: true,
        expanded: "yes",
        background: "",
      }));
    }
  };

  const resetDatesFn = () => {
    setState((prevState) => ({
      ...prevState,
      fromDate: "",
      toDate: "",
    }));
  };

  const handleDateBox = (selectedDate, name) => {
    let fromDate = new Date(dateFormatter.formatterThree(state.fromDate));
    let toDate = new Date(dateFormatter.formatterThree(state.toDate));
    let sDate = new Date(dateFormatter.formatterThree(selectedDate));
    localStorage.setItem("dateRangeLabel1", "Custom Range");
    if (name === "FromDate") {
      let startDate = dateFormatter.formatterTwo(sDate);
      let endDate = dateFormatter.formatterTwo(toDate);
      localStorage.setItem("t1StartDate", startDate);
      setState((prevState) => ({
        ...prevState,
        fromDate: startDate,
        isOpen: false,
        expanded: "",
        background: "hidden",
      }));
    } else if (name === "ToDate") {
      let startDate = dateFormatter.formatterTwo(fromDate);
      let endDate = dateFormatter.formatterTwo(sDate);
      localStorage.setItem("t1EndDate", endDate);
      setState((prevState) => ({
        ...prevState,
        toDate: endDate,
        isOpen: false,
        expanded: "",
        background: "hidden",
      }));
    }
  };

  const closeAdvSearch = () => {
    setState((prevState) => ({
      ...prevState,
      isOpen: false,
      expanded: "",
      background: "hidden",
    }));
  }

  useEffect(() => {
    if (state.fromDate && state.toDate) {
      pendingProposalData(state.fromDate, state.toDate);
    }
  }, [state.fromDate, state.toDate]);

  const renderAdvancedSearch = () => {
    return (
      <div className="w-full">
        <div className="md:mt-5 mt-1 flex xl:justify-end">
          <button
            onClick={() => filtersDropdown()}
            className={`focus:outline-none text-white hover:bg-blue-800 dark:ring-0 font-medium rounded-lg text-sm px-5 py-2.5 me-2 mb-2 ${state.isOpen ? "bg-blue-700 text-white dark:bg-white/20" : "bg-blue-500 hover:dark:bg-white/20 dark:bg-white/10 dark:text-white"}`}
          >
            Advanced Search
          </button>
        </div>
        {state.isOpen && (
          <>
            <div className="w-full mt-1">
              <div className="pb-4">
                <div className="grid grid-cols-6 gap-6">
                    <div className="md:py-3 col-span-6 md:col-span-2 ">
                      <MultiSelection
                        id="program"
                        label="Select Programs"
                        selectedValues={state.programsSelectedList}
                        data={state.allPrograms}
                        onSelect={(selectedList, selectedItem) =>
                          onMultiSelectChange(selectedList, selectedItem, "program")
                        }
                        onRemove={(selectedList, removedItem) =>
                          onMultiSelectChange(selectedList, removedItem, "program")
                        }
                      />
                    </div>
                    <div className="md:py-3 col-span-6 md:col-span-2 ">
                      <MultiSelection
                        id="campus"
                        label="Select Campuses"
                        selectedValues={state.campusSelectedList}
                        onSelect={(selectedList, selectedItem) =>
                          onMultiSelectChange(selectedList, selectedItem, "campus")
                        }
                        onRemove={(selectedList, removedItem) =>
                          onMultiSelectChange(selectedList, removedItem, "campus")
                        }
                        data={state.allCampuses}
                        placeholder="Select"
                      />
                    </div>
                    <div className="md:py-3 col-span-6 md:col-span-2 ">
                      <MultiSelection
                        id="acManager"
                        label="Select Account Managers"
                        selectedValues={state.acManagerSelectedList}
                        onSelect={(selectedList, selectedItem) =>
                          onMultiSelectChange(selectedList, selectedItem, "acManager")
                        }
                        onRemove={(selectedList, removedItem) =>
                          onMultiSelectChange(selectedList, removedItem, "acManager")
                        }
                        data={state.allAccountManagers}
                        placeholder="Select"
                      />
                    </div>
                    <div
                      className={
                        (state.allIntakes != "" ? "" : "hidden") +
                        " md:py-3 col-span-6 md:col-span-3 "
                      }
                    >
                      <MultiSelection
                        id="intake"
                        label="Select Intakes"
                        selectedValues={state.intakesSelectedList}
                        onSelect={(selectedList, selectedItem) =>
                          onMultiSelectChange(selectedList, selectedItem, "intake")
                        }
                        onRemove={(selectedList, removedItem) =>
                          onMultiSelectChange(selectedList, removedItem, "intake")
                        }
                        data={state.allIntakes}
                        placeholder="Select"
                      />
                    </div>
                  </div>
              </div>
            </div>
          </>
        )}
      </div>
    );
  };

  const upload = (file, docTypeId) => {
    setState((prevState) => ({ ...prevState, uploadFile: file }));
  };

  const uploadFile = async () => {
    var file = state.uploadFile;
    const objectType = 29; //proposal type
    const objectID = parseInt(state.fileProposalID); //Applicant Id
    if (file) {
      if (file.length > 0) {
        setState((prevState) => ({
          ...prevState,
          hidden: "",
          isLoaded: true,
        }));

        let form = new FormData();

        form.append("file", file[0]);
        form.append("objectId", objectID);
        form.append("objectType", objectType);
        form.append("isPublic", 1);

        try {
          Axios.post(constants.BASEURL + "Document", form).then((result) => {
            if ((result.data.sucess = false)) {
              alert("Fail");
            } else {
              alert("Success");
              setState((prevState) => ({
                ...prevState,
                uploaderHidden: "hidden",
                uploaderBkgrd: "hidden",
                hidden: "hidden",
                isLoaded: false,
              }));
            }
          });
        } catch (e) {
          alert("Error while uploading ");
        }
      }
    }
  };

  useEffect(() => {
    loadData();
  }, [
    state.allPrograms,
    state.allCampuses,
    state.allIntakes,
    state.allAccountManagers,
    state.pProposalData,
    state.searchFieldValue,
    state.firstRowIndex,
    state.lastRowIndex,
    state.sortBy,
    state.commissionOrder,
    state.upAlphabetSvg,
    state.downAlphabetSvg,
    state.upCommissionnSvg,
    state.downCommissionnSvg,
    state.isOpen,
    state.expanded,
    state.background,
    state.fromDate,
    state.toDate,
    state.programsSelectedList,
    state.campusSelectedList,
    // Removed invoiceNoSelectedList as it wasn't in this component's state
  ]);

  // --- CSV DOWNLOAD HANDLER ---
  const handleDownload = () => {
    // 1. We copy the raw data, then apply the active filters & sorting
    // This ensures what downloads matches exactly what the user sees
    let data = [...state.pProposalData]; // Spread array so we don't mutate state directly with sort
    data = dataProcessor(data);
    data = dataSortingFn(data);

    // 2. Define headers for Pending Proposals
    const headers = [
      "Student Name", 
      "Application No", 
      "Processed Date", 
      "Program Name", 
      "Start Date", 
      "End Date", 
      "Campus", 
      "Account Manager", 
      "Intake", 
      "Commission"
    ];

    // 3. Define the exact keys in pProposalData that map to the headers above
    const keys = [
      "studentName", 
      "proposalNo", 
      "proposalDate", 
      "courseName", 
      "courseStartDate", 
      "courseEndDate", 
      "campus", 
      "accountManagerName", 
      "intake", 
      "commission"
    ];

    // 4. Set the dynamic file name
    const fileName = `Pending_Applications_${moment().format("DD-MM-YYYY")}`;

    // 5. Call our reusable download helper!
    downloadCSV(data, headers, keys, fileName);
  };

  // following function will rende main GUI
  return (
    <div className="relative mt-4 align-middle min-h-full">
      <Loader id={"t1"} loaded={state.isLoaded} hidden={state.hidden}></Loader>

      {/* REPLACED HEADER TITLE WITH THE NEW BUTTON */}
      <div className="col-span-6 flex justify-between items-center mb-4">
        <div className="text-left text-2xl text-blue-500 font-semibold dark:text-white">
          Pending Applications Listing
        </div>
        {state.pProposalData.length > 0 && (
          <button
            onClick={handleDownload}
            className="group flex items-center gap-2 px-4 py-2 text-sm font-semibold text-white transition-all duration-300 ease-out bg-gradient-to-br from-emerald-400 to-emerald-600 rounded-lg shadow-md shadow-emerald-500/30 hover:shadow-lg hover:shadow-emerald-500/50 hover:-translate-y-0.5 border border-emerald-400/20 active:scale-95 active:translate-y-0"
            title="Download as CSV"
          >
            <svg
              className="w-4 h-4 transition-transform duration-300 group-hover:-translate-y-0.5"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2.5}
                d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4"
              />
            </svg>
            Download CSV
          </button>
        )}
        
      </div> 

      <div className="rounded-md p-4 bg-white mb-4 md:mb-8 w-full grid grid-cols-1 gap-5 md:grid-cols-2 xl:grid-cols-6 dark:bg-white/10 shadow-md">
        <div className="xl:col-span-2">
          <SearchBox
            id={"search"}
            label={"Search For Student Name"}
            svgType={"student"}
            placeholder={"Name"}
            value={state.searchFieldValue}
            searchHandler={() => {
              searchHandeler();
            }}
          />
        </div>

        <div className="xl:col-span-2">
          <DateBox
            dependentOn={true}
            id={"Pd1"}
            label="Processed From Date"
            onChange={handleDateBox}
            name={"FromDate"}
            value={state.fromDate ? new Date(state.fromDate) : ""}
          />
        </div>
        <div className="xl:col-span-2">
          <DateBox
            dependentOn={true}
            id={"Pd1"}
            label="Processed Till Date"
            onChange={handleDateBox}
            name={"ToDate"}
            value={state.toDate ? new Date(state.toDate) : ""}
          />
        </div>
        <div className="xl:col-span-6">{renderAdvancedSearch()}</div>
      </div>
      <div
        className={
          state.uploaderHidden + " z-40 child w-70per h-60per bg-yellow-100 p-6"
        }
      >
        <div className="h-80percent">
          <Uploader
            onUpload={(file, docTypeId) => {
              upload(file, docTypeId);
            }}
            docTypeId={"AgentDocuments"}
          />
        </div>
        <div className="sm:border-t sm:border-gray-200 sm:pt-5 w-full flex justify-center">
          <button
            id="submit"
            type="button"
            onClick={() => {
              uploadFile();
            }}
            className="inline-flex justify-center py-1 px-4 border border-transparent text-base leading-6 font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-500 focus:outline-none focus:border-indigo-700 focus:shadow-outline-indigo active:bg-indigo-700 transition duration-150 ease-in-out"
          >
            Submit
          </button>
        </div>
      </div>
      <div className="mb-6 w-full align-middle">{renderTable()}</div>
      <div className="">
        <span
          onClick={() => eventHandeler(0, "close")}
          className={
            state.uploaderBkgrd +
            " z-30 fixed top-10 left-0 right-0 bottom-0 h-full w-full bg-black opacityBackground"
          }
        />
      </div>
    </div>
  );
};

export default PendingProposals;